import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import moment from 'moment';
import 'moment/locale/ms';

// Load translation files
import enCommon from '../locales/en/common.json';
import enCompanyDetail from '../locales/en/companydetail.json';
import enCompanies from '../locales/en/companies.json';
import enHomepage from '../locales/en/homepage.json';
import enDropResume from '../locales/en/dropresume.json';
import enFooter from '../locales/en/footer.json';
import enInternship from '../locales/en/internship.json';
import enJobs from '../locales/en/jobs.json';
import enNav from '../locales/en/nav.json';
import enSignInForm from '../locales/en/sign_in_form.json';
import enSignUpForm from '../locales/en/sign_up_form.json';
import enUserProfile from '../locales/en/userprofile.json';
import enOverview from '../locales/en/overview.json';
import enPreference from '../locales/en/preference.json';
import enResetForm from '../locales/en/reset_form.json';
import msCommon from '../locales/ms/common.json';
import msCompanyDetail from '../locales/ms/companydetail.json';
import msCompanies from '../locales/ms/companies.json';
import msHomepage from '../locales/ms/homepage.json';
import msDropResume from '../locales/ms/dropresume.json';
import msFooter from '../locales/ms/footer.json';
import msInternship from '../locales/ms/internship.json';
import msJobs from '../locales/ms/jobs.json';
import msNav from '../locales/ms/nav.json';
import msSignInForm from '../locales/ms/sign_in_form.json';
import msSignUpForm from '../locales/ms/sign_up_form.json';
import msUserProfile from '../locales/ms/userprofile.json';
import msOverview from '../locales/ms/overview.json';
import msPreference from '../locales/ms/preference.json';
import msResetForm from '../locales/ms/reset_form.json';

const enTranslation = {
  ...enCommon,
  companydetail: enCompanyDetail,
  companies: enCompanies,
  nav: enNav,
  homepage: enHomepage,
  dropresume: enDropResume,
  footer: enFooter,
  internship: enInternship,
  jobs: enJobs,
  sign_in_form: enSignInForm,
  sign_up_form: enSignUpForm,
  userprofile: enUserProfile,
  overview: enOverview,
  preference: enPreference,
  reset_form: enResetForm,
};

const msTranslation = {
  ...msCommon,
  companydetail: msCompanyDetail,
  companies: msCompanies,
  nav: msNav,
  homepage: msHomepage,
  dropresume: msDropResume,
  footer: msFooter,
  internship: msInternship,
  jobs: msJobs,
  sign_in_form: msSignInForm,
  sign_up_form: msSignUpForm,
  userprofile: msUserProfile,
  overview: msOverview,
  preference: msPreference,
  reset_form: msResetForm,
};

const setMomentLocale = (language) => {
  const normalizedLanguage = language?.toString().toLowerCase() ?? '';
  moment.locale(normalizedLanguage.startsWith('ms') ? 'ms' : 'en');
};

const isBrowser = typeof window !== "undefined";

if (isBrowser) {
  i18n.use(LanguageDetector);
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation },
      ms: { translation: msTranslation }
    },
    ...(isBrowser
      ? {
          detection: {
            order: ['cookie', 'localStorage', 'navigator'],
            lookupCookie: 'i18next',
            caches: ['cookie', 'localStorage'],
            cookieMinutes: 60 * 24 * 365
          },
        }
      : { lng: 'en' }),
    fallbackLng: 'en',
    debug: true,
    interpolation: {
      escapeValue: false
    }
  });

setMomentLocale(i18n.resolvedLanguage || i18n.language);
i18n.on('languageChanged', setMomentLocale);

export default i18n;
